/**
 * `ResetIconButton` — the relocated Reset control (ADR-0163 amendment
 * 2026-07-05). Reset is a rare action (Run-again already restarts a
 * completed journey), so it moved out of the sticky strip into the
 * card headers beside the `ViewToggle`: `EndpointColumn` on desktop,
 * `UnifiedPhaseList` on mobile. Compact 28px icon; same tooltip copy
 * and disabled treatment the strip button carried.
 */

import { RotateCcw } from 'lucide-react';

import { Tooltip } from '../../../components/atoms/index.js';
import { useC } from '../../../lib/theme.js';

export interface ResetIconButtonProps {
  canReset: boolean;
  onReset: () => void;
}

export function ResetIconButton({ canReset, onReset }: ResetIconButtonProps): JSX.Element {
  const C = useC();
  return (
    <Tooltip content={canReset ? 'Reset to start' : 'Nothing to reset yet'}>
      <button
        onClick={onReset}
        disabled={!canReset}
        aria-label="Reset to start"
        className="flex items-center justify-center flex-shrink-0"
        style={{
          width: 28,
          height: 28,
          background: 'transparent',
          color: canReset ? C.text : C.dim,
          border: `1px solid ${canReset ? C.border : C.borderSoft}`,
          borderRadius: 2,
          opacity: canReset ? 1 : 0.5,
          cursor: canReset ? 'pointer' : 'not-allowed',
        }}
      >
        <RotateCcw size={11} />
      </button>
    </Tooltip>
  );
}
